// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

  .popover-paper {
    border-radius: 10px !important;
    box-shadow: 0px 0px 3px 2px rgb(248,248,248) !important;
  }
  
  /* Hide the first column management option */
.MuiDataGrid-panelWrapper .MuiDataGrid-columnsManagementHeader + .MuiDataGrid-columnsManagement .MuiFormControlLabel-root:first-child {
  display: none !important;
}

[data-testid="VisibilityOffIcon"] {
  display: none !important;
}

.MuiList-root .MuiMenuItem-root:has([data-testid="VisibilityOffIcon"]) {
  display: none !important;
}


.custom-grid {
  width: 100%;
  max-width: 100%;
}

.ag-GridError {
  margin-top: 1rem;
  margin-right: 20px;
  margin-left: 20px;
}

.ag-header-cell.center-header {
  .ag-header-cell-label {
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/workbench/Workbench.css"],"names":[],"mappings":";;EAEE;IACE,8BAA8B;IAC9B,uDAAuD;EACzD;;EAEA,4CAA4C;AAC9C;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;;AAGA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF","sourcesContent":["\n\n  .popover-paper {\n    border-radius: 10px !important;\n    box-shadow: 0px 0px 3px 2px rgb(248,248,248) !important;\n  }\n  \n  /* Hide the first column management option */\n.MuiDataGrid-panelWrapper .MuiDataGrid-columnsManagementHeader + .MuiDataGrid-columnsManagement .MuiFormControlLabel-root:first-child {\n  display: none !important;\n}\n\n[data-testid=\"VisibilityOffIcon\"] {\n  display: none !important;\n}\n\n.MuiList-root .MuiMenuItem-root:has([data-testid=\"VisibilityOffIcon\"]) {\n  display: none !important;\n}\n\n\n.custom-grid {\n  width: 100%;\n  max-width: 100%;\n}\n\n.ag-GridError {\n  margin-top: 1rem;\n  margin-right: 20px;\n  margin-left: 20px;\n}\n\n.ag-header-cell.center-header {\n  .ag-header-cell-label {\n    justify-content: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
